import React from 'react';
import { OFFER_ANCHOR } from '../../data/content';
interface CtaButtonProps {
  children: React.ReactNode;
  href?: string;
  external?: boolean;
  size?: 'md' | 'lg';
  className?: string;
}
export function CtaButton({
  children,
  href = OFFER_ANCHOR,
  external = false,
  size = 'md',
  className = ''
}: CtaButtonProps) {
  const sizes: Record<string, string> = {
    md: 'px-5 py-3 text-[0.8rem] sm:text-sm',
    lg: 'px-6 py-3.5 text-sm sm:text-base md:text-lg'
  };
  return <a href={href} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : undefined} className={`inline-flex w-full max-w-xl items-center justify-center rounded-lg border-b-4 border-volt-dark bg-volt text-center font-display uppercase leading-tight tracking-wide text-carbon shadow-[0_6px_20px_rgba(255,213,0,0.25)] transition-colors duration-150 ease-soft hover:bg-volt-dark ${sizes[size]} ${className}`} data-id="element-248" data-mp="1qvurl9y966a4">
      {children}
    </a>;
}